/* apps/IDSImpactApp/src/app/shared/doc-viewer/doc-viewer.component.scss */
#documenteditor_title_contentEditor {
  height: 26px;
  max-width: 75%;
  width: auto;
  overflow: hidden;
  display: inline-block;
  padding-left: 4px;
  padding-right: 4px;
  margin: 5px;
}
.loading-shade {
  background: rgba(0, 0, 0, 0.15);
  position: absolute;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  display: flex;
  z-index: 1;
  width: 100%;
  height: 100%;
}
.single-line {
  cursor: text !important;
  outline: none;
}
#default_title_bar {
  height: 64px;
  line-height: 26px;
  width: 100%;
  font-size: 12px;
  font-family: inherit;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: inset 0px -1px 0px #e3e3e3;
  border-radius: 5px 5px 0px 0px;
  margin-left: 0;
  margin-right: 0;
}
#default_title_bar .document-detail-title-mobile {
  font-size: 24px !important;
}
#default_title_bar mat-icon {
  font-size: 24px !important;
}
[class^=e-de-icon-],
[class*=" e-de-icon-"] {
  font-family: "Sample brower icons" !important;
}
.e-de-icon-Print:before {
  content: "\e723";
}
.e-de-icon-Download:before {
  content: "\e728";
}
.save-to-pdf-btn {
  width: 153px !important;
  height: 40px !important;
  background: #41404d !important;
  margin: 12px 3px 12px 12px;
}
.save-btn {
  background: #3e92cc !important;
  width: 96px !important;
  height: 40px !important;
  margin: 12px 15px 12px 12px;
}
.action-right {
  float: right;
}
.action-left {
  float: left;
}
.btn-custom {
  vertical-align: middle !important;
  line-height: 20px !important;
  font-size: 17px !important;
  margin: 22px 0px 22px 0px !important;
}
.center {
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  align-items: center;
  text-align: center;
  color: #41404d;
  margin: 20px 0 20px 0 !important;
}
.pdf-popup .mat-dialog-container {
  padding: 0 !important;
}
.documenteditor {
  height: calc(100vh - 88px) !important;
}
.documenteditor-mobile {
  height: calc(100vh - 64px) !important;
}
.button-action {
  background-color: transparent;
}
.btn-cancel {
  padding-left: 0;
  font-size: 16px !important;
}
::ng-deep .document-detail-title-mobile {
  font-style: normal;
  font-weight: bold;
  font-size: 18px !important;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #41404d;
}
.btn-more {
  text-align: right;
  padding-right: 0;
  margin-right: auto;
  font-size: 16px !important;
}
.header-excel {
  display: flex;
  align-items: center;
}
.e-dlg-content {
  font-size: 24px;
}
/*# sourceMappingURL=doc-viewer.component.css.map */
